import { Box, Container, useTheme, useMediaQuery, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { CandidatePortalDataTestIds } from 'data-testids/general';
import { CandidateMatchDashboard } from 'features/Connect/features/ConnectCandidatePortalDashboards/CandidateMatchDashboard/CandidateMatchDashboardContainer';
import { NavigationTabMenu } from 'components/NavigationTabs/NavigationTabMenu';
import { candidateMenuOptions } from 'components/UserNavigationMenus/CandidateMenus/constants';
import { Route, Switch } from 'react-router-dom';
import { CandidatePortalRoutes } from './CandidateDashboardViews/utils/constants';
import { CandidatePortalProps } from './types';
import { useConnectContext } from 'features/Connect/features/Context/ConnectContextProvider';
import { useEffect } from 'react';
import auth from 'utils/auth';
import { useHistory } from 'react-router-dom';
import { useStateParam } from 'features/Connect/features/Context/ConnectStateCodeContextProvider';

const PortalDashboardPlaceholder = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h1">Dashboard Page</Typography>
    <Typography variant="body1">Dashboard content will go here</Typography>
  </Box>
);

export const CandidatePortal: React.FC<CandidatePortalProps> = ({
  defaultActiveTab = 'matches',
}) => {
  const { connectContextActions } = useConnectContext();
  const jobBoardState = useStateParam();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const user = auth.getUser();
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      await connectContextActions.fetchCandidateMatches(user);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CandidatePortalContainer
      maxWidth={false}
      disableGutters
      data-testid={CandidatePortalDataTestIds.CANDIDATE_PORTAL_CONTAINER}
    >
      <CandidatePortalContent>
        {!isMobile && (
          <CandidatePortalNavigationContainer>
            <NavigationTabMenu
              tabs={candidateMenuOptions.filter((option) => option.shouldShowCandidatePortalNavTab)}
              orientation="vertical"
              sx={{ width: '100%', backgroundColor: '#fff' }}
              defaultActiveTab={defaultActiveTab}
              tabProps={{
                history,
                isOnConnect: false,
                userType: user.profile.user_type,
                jobBoardState: jobBoardState,
                connectContextActions,
                connectUrlPath: '/candidate',
              }}
            />
          </CandidatePortalNavigationContainer>
        )}
        <CandidatePortalDashboardTabsContainer>
          <Switch>
            <Route exact path={CandidatePortalRoutes.MATCHES}>
              <CandidateMatchDashboard />
            </Route>
            <Route exact path={CandidatePortalRoutes.PROFILE}>
              <PortalDashboardPlaceholder />
            </Route>
            <Route exact path={CandidatePortalRoutes.MATCH_ARCHIVE}>
              <PortalDashboardPlaceholder />
            </Route>
          </Switch>
        </CandidatePortalDashboardTabsContainer>
      </CandidatePortalContent>
    </CandidatePortalContainer>
  );
};

const CandidatePortalContainer = styled(Container)({
  height: '100%',
  width: '100%',
});

const CandidatePortalContent = styled(Box)({
  display: 'flex',
  width: '100%',
  height: '100%',
});

const CandidatePortalNavigationContainer = styled(Box)(({ theme }) => ({
  width: '232px',
  minWidth: '180px',
  borderRight: `1px solid ${theme.palette.divider}`,
}));

const CandidatePortalDashboardTabsContainer = styled(Box)({
  flex: 1,
  width: '100%',
});
